import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateUserComponent } from './create-user.component';
import { ReactiveFormsModule } from '@angular/forms';
import { UserDetailsModule } from 'src/app/user-management/add-user/user-details/user-details.module';
import { UserTypeModule } from 'src/app/user-management/add-user/user-type/user-type.module';
import { AccessTimeModule } from 'src/app/user-management/add-user/access-time/access-time.module';
import { AccessDetailEmailModule } from 'src/app/user-management/add-user/access-detail-email/access-detail-email.module';
import { CompletedModule } from 'src/app/user-management/add-user/completed/completed.module';
import { UserGroupModule } from 'src/app/user-management/user-group/user-group.module';
import { VerifyEmailModule } from 'src/app/user-management/add-user/verify-email/verify-email.module';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { SelectedUnitsAccesspointsModule } from 'src/app/user-management/add-user/selected-units-accesspoints/selected-units-accesspoints.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';

@NgModule({
  declarations: [CreateUserComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UserDetailsModule,
    UserTypeModule,
    AccessTimeModule,
    AccessDetailEmailModule,
    VerifyEmailModule,
    CompletedModule,
    UserGroupModule,
    SharedLayoutModule,
    WithTooltipModule,
    SelectedUnitsAccesspointsModule,
  ],
  exports: [CreateUserComponent],
})
export class CreateUserModule {}
